
jQuery( function() {
    //Homepage Brand Slider
    if ( jQuery( '.owl-carousel.brand--slider' ).length > 0 ) {
        jQuery( '.owl-carousel.brand--slider' ).owlCarousel( {
            loop: false,
            rewind: true,
            responsiveClass: true,
            margin: 20,
            dots: false,
            nav: true,
            autoplay: true,
            navText: ['<svg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="M4.998 10.012a.997.997 0 0 1-.707-.293l-4-4a1.004 1.004 0 0 1 0-1.414l4-4a1 1 0 1 1 1.414 1.414L2.412 5.012l3.293 3.293c.187.188.293.442.293.707 0 .549-.452 1-1 1Z" fill="currentColor" /></svg>', '<svg viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg"><path d="M1.012 10.012c.265 0 .52-.105.707-.293l4-4a1.004 1.004 0 0 0 0-1.414l-4-4A1 1 0 1 0 .305 1.719l3.293 3.293L.305 8.305a1.002 1.002 0 0 0-.292.707c0 .549.451 1 .999 1Z" / fill="currentColor"></svg>'],
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 4
                }
            }
        } );
    }
})